// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__103ut","wrapper":"styles_wrapper__1j12K","logo":"styles_logo__2I-b3","small":"styles_small__2H10a"};